import { MarketingWin } from './entities';

// actual object is much bigger and complex. Ignoring the rest for now.
export interface IngressMarketingWin {
  sys: {
    id: string;
  };
  fields: {
    name: string;
    product: string;
    symbol: string;
    theWin: string;
    theWinDetailed: string;
    date: string;
    percentGain?: number;
    tradeType: string;
  };
}
export interface IngressMarketingWinsResponse {
  items: IngressMarketingWin[];
}

export function ingressMarketingWinResponse(response: IngressMarketingWinsResponse): MarketingWin[] {
  return response.items.map(w => {
    return {
      ...w.fields,
      id: w.sys.id,
    };
  });
}
